import React, {useEffect} from 'react';
import { EntityId } from "@reduxjs/toolkit";
import {useAppDispatch, useAppSelector} from "../../../../store/hooks";
import { selectUserEntities, selectUserIds } from "../../../../store/mine_craft/usersSlice";

import { Spin } from "antd";
import Pagination from '../../../../componets/Pagination';
import ListItem from "./_ListItem";
import { fetchPreviewAddons } from "../../../../actions/mine_craft/addonsActions";
import {useSearchParams} from "react-router-dom";

interface propsInterface {
  limit: number;
}

const _List = ({ limit }: propsInterface) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const ids             = useAppSelector(selectUserIds);
  const items           = useAppSelector(selectUserEntities);
  const previewAddons   = useAppSelector(state => state.mineCraft.users.previewAddons);
  const count           = useAppSelector(state => state.mineCraft.users.count);
  const error           = useAppSelector(state => state.mineCraft.users.error);
  const status          = useAppSelector(state => state.mineCraft.users.status);
  const term            = searchParams.get('term') || '';

  useEffect(() => {
    dispatch(fetchPreviewAddons({ id: previewAddons, limit: 210 }));
  }, [previewAddons, dispatch]);

  const renderList = (id: EntityId) => {
    const item = items[id];

    if (!item) {
      return;
    }

    return (
      <ListItem key={item.id} user={item} term={term} />
    )
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      <div className='v-users-list'>
        {ids && ids.map(renderList)}
      </div>

      <Pagination total={count} size={limit} className='v-mt-10' />
    </>
  );
}

export default _List;
